// DashboardTimeGraph Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ProgressCircle from '../../graph/progress_circle/progress_circle.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import { buildTimer } from '../../../common/timer/timer'

class DashboardTimeGraph extends Component {
  constructor (props) {
    super(props)
    this.data = {
      sort: 'company',
      sortAsc: true
    }
  }

  static get propTypes () {
    return {
      timeTaken: PropTypes.number,
      timeTotal: PropTypes.number,
      showAdd: PropTypes.bool,
      type: PropTypes.oneOf(['thisweek', 'lastweek', 'beforeweek', 'planner']),
      onAdd: PropTypes.func,
      onStartTimer: PropTypes.func,
      onPauseTimer: PropTypes.func,
      onStopTimer: PropTypes.func,
      showTimer: PropTypes.bool,
      showAddTimer: PropTypes.bool,
      onAddTimeCard: PropTypes.func,
      timer: PropTypes.object,
      onClickProgressCircle: PropTypes.func,
      stopAndCreateNewTimeCard: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      timeTaken: 0,
      timeTotal: 0,
      showAdd: false,
      type: 'thisweek',
      onAdd: null,
      onStartTimer: null,
      onPauseTimer: null,
      onStopTimer: null,
      showTimer: false,
      showAddTimer: false,
      timer: buildTimer(null),
      onAddTimeCard: null,
      onClickProgressCircle: null,
      stopAndCreateNewTimeCard: null
    }
  }

  render () {
    const {
      showAdd,
      type,
      timeTaken,
      timer,
      showTimer,
      showAddTimer,
      onAddTimeCard
    } = this.props

    let showAddTimeCard = true
    if (timer.TimeCard()) {
      const minutesInOneDay = 24 * 60
      showAddTimeCard = timer.TimeCard().timeTaken < minutesInOneDay
    }

    const FullTimeWeekInMinutes = 2400
    const timeTotal = this.props.timeTotal || FullTimeWeekInMinutes
    const bTimerStarted = timer.isStarted() && showAddTimeCard
    const bTimerPaused = timer.isPaused() && showAddTimeCard

    const currDate = DateUtil.getUTCCurrentDate()
    let activeDate = new Date(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate()
    )
    const currWeekNo = DateUtil.getLocalWeekNo(activeDate)
    const weeksDiff = currWeekNo - (currWeekNo - 2)
    activeDate = new Date(
      activeDate.getFullYear(),
      activeDate.getMonth(),
      activeDate.getDate() - weeksDiff * 7
    )
    const currLastBeforeWeekNo = DateUtil.getLocalWeekNo(activeDate)

    let outerColor = ''
    let innerColor = ''
    let info = ''
    let subTime = ''
    let subInfo = ''
    let width = 0
    let height = 0
    let options = []

    let bSuccess = false
    if (timeTaken >= timeTotal) {
      bSuccess = true
    }

    if (type === 'thisweek') {
      outerColor = '#11496b'
      innerColor = !bSuccess ? '#4dbce9' : '#7abd9a'
      info = IntlUtil.convertMessage(
        bTimerStarted ? 'common.dashboard.timing' : 'common.dashboard.thisWeek'
      )
      width = '190'
      height = '190'
    } else if (type === 'lastweek') {
      outerColor = bSuccess ? '#4dbce9' : '#ff6566'
      innerColor = bSuccess ? '#7abd9a' : '#4dbce9'
      info = IntlUtil.convertMessage('common.dashboard.lastWeek')
      width = '130'
      height = '130'
    } else if (type === 'beforeweek') {
      outerColor = bSuccess ? '#4dbce9' : '#ff6566'
      innerColor = bSuccess ? '#7abd9a' : '#4dbce9'
      info = `${IntlUtil.convertMessage(
        'common.dashboard.week'
      )} ${currLastBeforeWeekNo}`
      width = '130'
      height = '130'
    } else if (type === 'planner') {
      outerColor = '#fff'
      innerColor = '#4ebae8'
      subTime = '02:00'
      subInfo = 'Planned'
      options = this._getSortOptions()
      width = '230'
      height = '230'
    }

    const _className = classnames('dashboard-timegraph', {}, `${type}`)

    // timerTimeSpent is only used when the timer is running
    const timerTimeSpent = timer.calculateTimeSpent(timeTaken)

    return (
      <div className={_className}>
        <ProgressCircle
          outerColor={outerColor}
          info={info}
          innerColor={innerColor}
          subTime={subTime}
          subInfo={subInfo}
          options={options}
          dropValue={this.data.sort}
          onSort={this._onSort.bind(this)}
          width={width}
          height={height}
          value={timeTaken}
          timeSpent={timerTimeSpent}
          totalValue={timeTotal}
          onClickCircle={this._onClickProgressCircle.bind(this)}
          bShowTime
          borderWidth='5'
          showTimer={showTimer}
          timer={timer}
          stopAndCreateNewTimeCard={this.props.stopAndCreateNewTimeCard}
        />
        {type === 'thisweek' ? (
          bTimerStarted ? (
            <IconButton
              icon='dashboard-stat-pause'
              title='task.item.timePause'
              onClick={this._onPauseTimer.bind(this)}
              size='big'
              canHover={false}
              className='dashboard_graphweek timerstartbig'
            />
          ) : bTimerPaused ? (
            <IconButton
              icon='dashboard-stat-start'
              title='task.item.timeStart'
              onClick={this._onStartTimer.bind(this)}
              size='big'
              canHover={false}
              className='dashboard_graphweek timerstartbig'
            />
          ) : (
            <IconButton
              className='dashboard_graphweek'
              type='primary'
              size='big'
              icon='dashboard-graphadd'
              title='common.dashboard.titleAdd'
              canHover={false}
              onClick={onAddTimeCard}
            />
          )
        ) : null}
        {showAdd && type === 'planner' && (
          <IconButton
            className='dashboard_graphplanner'
            type='primary'
            size='big'
            icon='dashboard-graphadd'
            title='common.dashboard.titleAdd'
            canHover={false}
            onClick={this._onClickAdd.bind(this)}
          />
        )}
        {bTimerStarted || bTimerPaused ? (
          <IconButton
            icon='dashboard-stat-stop'
            type='primary'
            title='task.item.timeStop'
            onClick={this._onStopTimer.bind(this)}
            size='big'
            canHover={false}
            className='dashboard_graphweek timmer'
          />
        ) : (
          showAddTimer && (
            <IconButton
              className='dashboard_timer timmer'
              size='big'
              icon='time-starttimer'
              title='common.dashboard.titleAddTimer'
              canHover={false}
              onClick={this._onStartTimer.bind(this)}
            />
          )
        )}
        {bSuccess && (
          <div className='progress-medal'>
            <img
              src='/images/common/dashboard_medal.png'
              className='inline-image'
              alt={IntlUtil.convertMessage('common.dashboard.textMedal')}
            />
          </div>
        )}
      </div>
    )
  }

  /* Event handler */
  _onStartTimer () {
    if (this.props.onStartTimer) {
      this.props.onStartTimer()
    }
  }

  _onPauseTimer () {
    if (this.props.onPauseTimer) {
      this.props.onPauseTimer()
    }
  }

  _onStopTimer () {
    if (this.props.onStopTimer) {
      this.props.onStopTimer()
    }
  }

  /* Private Function */
  _onClickAdd (e) {
    e.preventDefault()

    if (this.props.onAdd) {
      this.props.onAdd(e)
    }
  }

  _getSortOptions () {
    return [
      {
        label: 'common.dashboard.sortLabelConcept',
        value: 'company'
      },
      {
        label: 'common.dashboard.sortLabelVan',
        value: 'company'
      }
    ]
  }

  _onSort (sort, sortAsc) {
    this.data.sort = sort
    this.data.sortAsc = sortAsc
  }

  _onClickProgressCircle () {
    if (this.props.onClickProgressCircle) {
      this.props.onClickProgressCircle()
    }
  }
}

export default DashboardTimeGraph
